<template>
    <Progressbar v-if="loading && !meta.current_page" />
    <NetworkError v-else-if="errors" @tryAgain="getData" />
    <div class="flex flex-row gap-6 w-full h-full" v-else>
        <div class="flex flex-1 flex-col overflow-hidden">
            <div class="flex items-center">
                <div class="alert bg-green-custom-1 text-green-custom-2 h-8 lg:h-12 py-0 px-2 md:px-4">
                    <span class="m-auto"> {{ __('Factor List') }}</span>
                </div>

                <label for="export-modal" class="btn btn-square btn-sm lg:btn-md btn-error mr-3 px-2"
                    v-if="activeTab === 1">
                    <svg style="color: white" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                        class="w-5 h-5 md:w-7 md:h-7" viewBox="0 0 16 16">
                        <path
                            d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
                            fill="white"></path>
                        <path
                            d="M4.603 12.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.701 19.701 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.187-.012.395-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.065.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.716 5.716 0 0 1-.911-.95 11.642 11.642 0 0 0-1.997.406 11.311 11.311 0 0 1-1.021 1.51c-.29.35-.608.655-.926.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.27.27 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.647 12.647 0 0 1 1.01-.193 11.666 11.666 0 0 1-.51-.858 20.741 20.741 0 0 1-.5 1.05zm2.446.45c.15.162.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.881 3.881 0 0 0-.612-.053zM8.078 5.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z"
                            fill="white"></path>
                    </svg>
                </label>
                <label class="btn btn-error btn-sm lg:btn-md btn-outline mr-3" for="delete-modal" @click="setOrder({})"
                    v-if="activeTab === 1 && orders.length">{{ __('Delete invoices of the last 30 days') }}</label>
            </div>
            <!-- <div class="tabs mt-3 lg:mt-4">
                <a class="tab tab-bordered" :class="{ 'tab-active bg-white': activeTab === 1 }" @click="setActiveTab(1)">{{
                    __('Orders')
                    }}</a>
                <a class="tab tab-bordered" :class="{ 'tab-active bg-white': activeTab === 2 }" @click="setActiveTab(2)">{{
                    __('Returned') }}</a>
            </div>
            <div class="tab-content h-full"> -->
                <NotFound v-if="!orders.length" />
                <div id="tab-order"
                    class="card product-item mt-4 bg-white scrollbar-thin scrollbar-thumb-base-300 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-track-base-200"
                    v-else>
                    <div class="card-body p-0">
                        <div>
                            <table class="table w-full table-compact md:table-normal">
                                <thead class="border-b">
                                    <tr>
                                        <th>{{ __(activeTab == 1 ? 'Order Id' : 'Return number') }}</th>
                                        <th>{{ __(activeTab == 1 ? 'Payable Amount' : 'Refund amount') }}</th>
                                        <th v-if="activeTab == 1">{{ __('Payment Method') }}</th>
                                        <th v-if="activeTab == 1">{{ __('Status') }}</th>
                                        <th v-else>{{ __('Product count') }}</th>
                                        <th>{{ __('Date') }}</th>
                                        <th>{{ __('Action') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="odd:bg-green-custom-2" v-for="order in orders">
                                        <td class="text-gray-custom-1 text-center">{{ order.id }}</td>
                                        <td class="text-center">
                                            <span class="text-red-custom-2">{{ order.amount.toLocaleString()
                                                }}</span>
                                            <Currency />
                                        </td>
                                           <td class="text-center text-info" v-if="activeTab == 1">
                                            {{ __(order.payment?.method) }}
                                        <small class="text-gray-custom-1" v-if="order.payment?.gateway">({{ __(order.payment?.gateway?.capitalize()) }})</small></td>
                                        <td class="text-center" v-if="activeTab == 1" :class="`text-${order.payment?.method != 'online' || order.payment?.status == 'complete' ? order.status.color : 'info'}`">
                                            {{ order.payment?.method != 'online' || order.payment?.status == 'complete' ? order.status.label : __('Awaiting payment') }}</td>
                                            <td class="text-gray-custom-1 text-center" v-else>{{ order.product_count }}</td>
                                        <td class="text-gray-custom-1 text-center">{{ order.created_at }}</td>
                                        <td class="text-center" v-if="activeTab == 1">
                                            <router-link class="btn btn-success btn-sm ml-2"
                                                :to="{ name: 'order', params: { id: order.id } }">
                                                <EyeIcon class="w-5 h-5" />
                                            </router-link>
                                            <label class="btn btn-error btn-sm ml-2" for="delete-modal"
                                                @click="setOrder(order)">
                                                <TrashIcon class="w-5 h-5" />
                                            </label>
                                            <button class="btn btn-dark btn-sm" @click="exportOrder(order)">
                                                <ArrowDownTrayIcon class="w-5 h-5" /> <span
                                                    class="hidden md:inline mr-2">{{
                                                        __('Invoice') }}</span>
                                            </button>
                                        </td>
                                         <td class="text-center" v-else>
                                             <router-link class="btn btn-success btn-sm ml-2"
                                                :to="{ name: 'order.return', params: { id: order.id } }">
                                                <EyeIcon class="w-5 h-5" />
                                            </router-link>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <LoadMore v-if="meta.current_page < meta.last_page" :errors="errors"
                            @tryAgain="getData(meta.current_page + 1)" />
                    </div>
                </div>
            <!-- </div> -->
        </div>
        <LeftSidebar :large="true" />
    </div>
    <Teleport to="#app">
        <input type="checkbox" id="export-modal" class="modal-toggle" />
        <div class="modal">
            <div class="modal-box max-w-md overflow-visible">
                <DatePicker v-model="exportData.date" :placeholder="__('Date Range')"
                    inputClass="!text-gray-custom-1 !placeholder-gray-custom-1" range clearable />
                <select class="select w-full mt-3" v-model="exportData.status">
                    <option value="">{{ __('Select Status...') }}</option>
                    <option v-for="step in meta.steps" :value="step.name">{{ step.label }}</option>
                </select>
                <div class="modal-action">
                    <label class="btn btn-secondary btn-sm" for="export-modal" @click="exportOrders">{{ __('Export')
                        }}</label>
                    <label class="btn btn-primary btn-sm" for="export-modal" @click="getOrders(1, true)">
                        {{ __('anti filter') }}
                    </label>
                    <label class="btn btn-error btn-sm" for="export-modal">{{ __('Close') }}</label>

                </div>
            </div>
        </div>
    </Teleport>
    <Teleport to="#app">
        <input type="checkbox" id="delete-modal" class="modal-toggle" />
        <label class="modal" for="delete-modal">
            <label class="modal-box" for="">
                <h3 class="font-bold text-lg">{{ __(order?.id ? 'Delete the invoice' : 'Delete the invoices') }}</h3>
                <p class="py-4">
                    {{ 
                    __(order?.id ? 'Are you sure to delete this invoice?' : 'Are you sure of removing invoices for the last 30 days?') }}
                </p>
                <div class="modal-action">
                    <label class="btn btn-primary btn-sm" for="delete-modal">{{ __('Cancel') }}</label>
                    <label class="btn btn-error btn-sm" @click="deleteOrder(order?.id)" for="delete-modal">{{
                        __('Delete') }}</label>
                </div>
            </label>
        </label>
    </Teleport>
</template>
<script setup>
import { computed, onMounted, onUpdated, ref, watch } from 'vue';
import {
    ArrowDownTrayIcon,
    EyeIcon,
    TrashIcon
} from '@heroicons/vue/24/outline'
import Currency from '../../svg/Currency.vue';
import DatePicker from 'vue3-persian-datetime-picker'
import LeftSidebar from "../layout/LeftSidebar.vue";
import useOrders from "../../../composables/shop/order";
let scrollbar = null;
const { errors, loading, order, orders, exportData, getOrders,getOrderReturns, exportOrder, exportOrders, deleteOrder, meta } = useOrders();
const activeTab = ref(1);
const setOrder = (item) => Object.assign(order, item);
const getData = (page = 1) => {
    if(activeTab.value == 1) getOrders(page);
    else getOrderReturns(page);
}
const setActiveTab = (tab) => {
    activeTab.value = tab;
    getData(1);
}
onMounted(() => {
    getData()
})

onUpdated(() => {
    scrollbar = document.querySelector('.product-item');
    if (scrollbar) scrollbar.addEventListener('scroll', (e) => {
        if (meta.current_page < meta.last_page && !loading.value && !errors.value && (scrollbar.scrollTop + scrollbar.offsetHeight) >= (scrollbar.scrollHeight - 8)) {
            getData(meta.current_page + 1);
        }
    });
});
</script>